import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.map.js";
import { mergeProps as _mergeProps, renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, createSlots as _createSlots, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import { computed, reactive, ref, watch } from 'vue';
import { useFileManager } from '@/share/hooks/common';
export default {
  __name: 'mg-upload',
  props: {
    multiple: {
      type: Boolean,
      default: true
    },
    params: {
      type: Object,
      default: () => ({})
    },
    // 附加的上传数据
    ttl: {
      type: Boolean,
      default: true
    },
    // true上传为临时文件，后面需要commitFiles提交，否则将系统将自动删除
    dir: {
      type: String,
      default: ''
    },
    // 上传的目录
    cate: {
      type: String,
      default: ''
    },
    // 上传的分类
    showProgress: {
      type: Boolean,
      default: true
    },
    limitSize: {
      type: Number,
      default: 10
    },
    // 大小限制,单位M
    limitCount: {
      type: Number,
      default: 1
    },
    showLimitCount: {
      type: Boolean,
      default: true
    },
    showLimitSize: {
      type: Boolean,
      default: true
    },
    paramName: {
      type: String,
      default: 'file'
    },
    // 上传参数名
    buttonText: {
      type: String,
      default: '上传文件'
    },
    buttonIcon: {
      type: String,
      default: 'vxe-icon-upload'
    },
    autoSubmit: {
      type: Boolean,
      default: true
    },
    imageTypes: {
      type: Array,
      default: () => ['jpg', 'jpeg', 'png', 'gif', 'webp']
    },
    fileTypes: {
      type: Array,
      default: () => ['doc', 'docx', 'xls', 'xlsx', 'ppt', 'pptx', 'pdf']
    },
    modelValue: {
      type: Array,
      default: () => []
    },
    showList: {
      type: Boolean,
      default: true
    },
    typeField: {
      type: String,
      default: 'ext'
    },
    nameField: {
      type: String,
      default: 'name'
    },
    urlField: {
      type: String,
      default: 'url'
    },
    sizeField: {
      type: String,
      default: 'size'
    },
    autoHiddenButton: {
      type: Boolean,
      default: true
    },
    showUploadButton: {
      type: Boolean,
      default: true
    },
    showRemoveButton: {
      type: Boolean,
      default: true
    },
    showDownloadButton: {
      type: Boolean,
      default: true
    },
    showPreview: {
      type: Boolean,
      default: true
    },
    mode: {
      type: String,
      default: 'all',
      validator: v => {
        return ['all', 'image', 'file'].indexOf(v) !== -1;
      }
    }
  },
  emits: ['update:modelValue', 'changed'],
  setup(__props, {
    expose: __expose,
    emit: __emit
  }) {
    const fileList = ref([]);
    const uploadRef = ref();
    const emit = __emit;
    const props = __props;
    const handleUpdateModelValue = val => {
      fileList.value = val || [];
      emit('changed', fileList.value);
      emit('update:modelValue', fileList.value);
    };
    const extensions = computed(() => {
      switch (props.mode) {
        case 'all':
          return [...props.imageTypes, ...props.fileTypes];
        case 'image':
          return [...props.imageTypes];
        case 'file':
          return [...props.fileTypes];
      }
      return [];
    });
    const {
      uploadOptions,
      uploadTTL,
      upload,
      removeFile,
      removeTmpFile,
      downloadFile,
      commitUploadFiles
    } = useFileManager({
      maxSize: props.limitSize * 1024 * 1024,
      allowExtensions: extensions.value,
      paramName: props.paramName,
      params: props.params
    });
    watch(() => [props.limitSize, props.fileTypes, props.imageTypes, props.mode, props.paramName, props.params], attrs => {
      const [limitSize, fileTypes, imageTypes, mode, paramName, params] = attrs;
      let allowExtensions = [];
      switch (mode) {
        case 'all':
          allowExtensions = [...imageTypes, ...fileTypes];
          break;
        case 'file':
          allowExtensions = [...fileTypes];
          break;
        case 'image':
          allowExtensions = [...imageTypes];
          break;
      }
      Object.assign(uploadOptions, {
        maxSize: limitSize * 1024 * 1024,
        allowExtensions,
        paramName,
        params
      });
    }, {
      immediate: true
    });
    const uploadProps = reactive({
      keyField: 'uid',
      showProgress: props.showProgress,
      multiple: props.multiple || props.limitCount > 1,
      limitSize: props.limitSize,
      limitCount: props.limitCount,
      showLimitCount: true,
      showLimitSize: true,
      autoSubmit: props.autoSubmit,
      buttonText: props.buttonText,
      buttonIcon: props.buttonIcon,
      imageTypes: props.imageTypes,
      fileTypes: props.fileTypes,
      mode: props.mode,
      showList: props.showList,
      typeField: props.typeField,
      nameField: props.nameField,
      urlField: props.urlField,
      sizeField: props.sizeField,
      autoHiddenButton: props.autoHiddenButton,
      showUploadButton: props.showUploadButton,
      showDownloadButton: props.showDownloadButton,
      showRemoveButton: props.showRemoveButton,
      showPreview: props.showPreview,
      async 'removeMethod'({
        option
      }) {
        const {
          fileId,
          name
        } = option;
        if (fileId) {
          return removeFile(option);
        } else if (name) {
          return removeTmpFile(option);
        }
        return Promise.resolve(false);
      },
      async 'uploadMethod'({
        file,
        updateProcess
      }) {
        if (props.ttl) {
          // 上传临时文件
          const res = await uploadTTL(file, updateProcess);
          return Promise.resolve(res);
        }
        // 上传正式文件
        const res = await upload(file, {
          dir: props.dir,
          cate: props.cate
        }, updateProcess);
        return Promise.resolve(res);
      },
      async 'downloadMethod'({
        option
      }) {
        return downloadFile(option);
      }
    });
    watch(() => [props.showProgress, props.multiple, props.limitSize, props.limitCount, props.showLimitCount, props.showLimitSize, props.autoSubmit, props.buttonText, props.buttonIcon, props.imageTypes, props.fileTypes, props.mode, props.showList, props.typeField, props.nameField, props.urlField, props.sizeField, props.autoHiddenButton, props.showUploadButton, props.showRemoveButton, props.showPreview], attrs => {
      const [showProgress, multiple, limitSize, limitCount, showLimitCount, showLimitSize, autoSubmit, buttonText, buttonIcon, imageTypes, fileTypes, mode, showList, typeField, nameField, urlField, sizeField, autoHiddenButton, showUploadButton, showRemoveButton, showPreview] = attrs;
      Object.assign(uploadProps, {
        showProgress,
        multiple: multiple || limitCount > 0,
        limitSize,
        limitCount,
        showLimitCount,
        showLimitSize,
        autoSubmit,
        buttonText,
        buttonIcon,
        imageTypes,
        fileTypes,
        mode,
        showList,
        typeField,
        nameField,
        urlField,
        sizeField,
        autoHiddenButton,
        showUploadButton,
        showRemoveButton,
        showPreview
      });
    }, {
      immediate: true
    });
    watch(() => props.modelValue, val => {
      fileList.value = val || [];
    }, {
      deep: true,
      immediate: true
    });
    const commitTempFiles = async () => {
      const tmpFileNames = fileList.value.filter(item => !item.fileId).map(item => item.name);
      if (tmpFileNames.length === 0) return Promise.resolve(false);
      const res = await commitUploadFiles({
        dir: props.dir,
        files: tmpFileNames
      });
      return Promise.resolve(res);
    };
    const methods = {
      'choose'() {
        !!uploadRef.value && uploadRef.value.choose();
      },
      'submit'(isFull) {
        !!uploadRef.value && uploadRef.value.submit(isFull);
      },
      commitTempFiles
    };
    __expose({
      ...methods
    });
    return (_ctx, _cache) => {
      const _component_vxe_upload = _resolveComponent("vxe-upload");
      return _openBlock(), _createBlock(_component_vxe_upload, _mergeProps({
        ref_key: "uploadRef",
        ref: uploadRef,
        "model-value": fileList.value
      }, uploadProps, {
        "onUpdate:modelValue": handleUpdateModelValue
      }), _createSlots({
        _: 2
      }, [_renderList(Object.keys(_ctx.$slots), key => {
        return {
          name: key,
          fn: _withCtx(scope => [_renderSlot(_ctx.$slots, key, _mergeProps({
            key: key
          }, scope))])
        };
      })]), 1040, ["model-value"]);
    };
  }
};